import * as React from 'react';

import { observer } from 'mobx-react';

import { FormStore } from '@estee/elc-form';
import { IContext, IFormValues } from '@estee/elc-form/typings/views/Form';

import { ICheckableItem, ISelectAll } from '~domain/entities/Config';
import {
    ckGroupItemWrapperClasses,
    ckGroupSelectAllWrapperClasses,
    classes,
    fieldLabelClasses
} from '~utils/Classes';
import { GridAreaItem } from '~views/common/SectionGrid';

import { FormItemAdapter } from './FormItemAdapter';

export interface ICheckboxGroupProps {
    items: ICheckableItem[];
    enabled?: boolean;
    selectAll?: ISelectAll;
    inputLabel: string;
    name: string;
    formStore: FormStore<IFormValues>;
}

export const TEST_ID_CHECKBOX_GROUP = 'checkbox-group';
const itemRowsWrapperClassName = classes('iam-checkboxGroup-rows-wrapper');

@observer
export class CheckboxGroup extends React.Component<ICheckboxGroupProps> {
    public static contextTypes = {
        form: () => null
    };

    private itemsFieldName = this.props.items.reduce((acc: string[], item: ICheckableItem) => {
        acc.push(item.name);

        return acc;
    }, []);

    private onChange = (isChecked?: boolean, fieldName?: string) => {
        const { selectAll, formStore } = this.props;
        const { form } = this.context as IContext;

        if (selectAll?.name === fieldName && fieldName && form) {
            // TODO: APACRIGEL-459 need to reuse the logic from Checkbox
            // Set item check status once select all is changed
            this.itemsFieldName.map((name) => {
                formStore.setFieldValue(name, isChecked ? 1 : 0);
                formStore.blurField(name);
            });
        } else if (selectAll?.name && form) {
            // Set select all value basing on the items check status
            const isAlreadyChecked = (item: string) => form.values[item];
            const selectAllValue = this.itemsFieldName.every(isAlreadyChecked);
            form.values[selectAll?.name] = selectAllValue;
        }
    };

    public render() {
        const { inputLabel, name: groupName, items, enabled, selectAll, formStore } = this.props;

        const checkboxGroupRows = items.map(({ name, labelKey }, index) => {
            return (
                <div className={ckGroupItemWrapperClasses(name)} key={index}>
                    <FormItemAdapter
                        {...{
                            name,
                            labelKey,
                            enabled,
                            onChange: this.onChange,
                            inputType: 'checkbox',
                            formStore
                        }}
                    />
                </div>
            );
        });

        if (selectAll) {
            const { name } = selectAll;
            const TEST_ID_ITEM = `IAM_ITEM_${name.toUpperCase()}`;
            const selectAllCheckboxRow = (
                <GridAreaItem
                    className={ckGroupSelectAllWrapperClasses(name)}
                    name={name}
                    data-test-id={TEST_ID_ITEM}
                >
                    <FormItemAdapter
                        {...{
                            ...selectAll,
                            enabled,
                            onChange: this.onChange,
                            inputType: 'checkbox',
                            formStore
                        }}
                    />
                </GridAreaItem>
            );
            checkboxGroupRows.splice(
                selectAll.position === 'top' ? 0 : checkboxGroupRows.length,
                0,
                selectAllCheckboxRow
            );
        }

        return (
            <>
                <div
                    className={fieldLabelClasses(groupName)}
                    data-test-id={TEST_ID_CHECKBOX_GROUP}
                    dangerouslySetInnerHTML={{ __html: inputLabel }}
                />
                <div className={itemRowsWrapperClassName}>{checkboxGroupRows}</div>
            </>
        );
    }
}
